import React, { useState } from 'react';
import { feEstadoBadge, truncateCufe } from '../../utils/feEstadoUi';

type FeEstadoBadgeProps = {
  estado?: string | null;
  cufe?: string | null;
  error?: string | null;
  showCufe?: boolean;
  className?: string;
};

export const FeEstadoBadge: React.FC<FeEstadoBadgeProps> = ({
  estado,
  cufe,
  error,
  showCufe = false,
  className = '',
}) => {
  const badge = feEstadoBadge(estado);
  const [copied, setCopied] = useState(false);
  if (!badge) return null;

  const copyCufe = async () => {
    const value = String(cufe || '').trim();
    if (!value) return;
    try {
      await navigator.clipboard.writeText(value);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1600);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className={`flex flex-col gap-0.5 min-w-0 ${className}`}>
      <span
        className={`inline-flex w-fit rounded-full px-2 py-0.5 text-xs font-medium ${badge.className}`}
        title={error || undefined}
      >
        {badge.label}
      </span>
      {showCufe && cufe ? (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            void copyCufe();
          }}
          className="text-left text-[10px] text-gray-600 hover:text-[#1A56DB] font-mono truncate max-w-[220px]"
          title="Copiar CUFE"
        >
          CUFE {copied ? 'copiado' : truncateCufe(cufe)}
        </button>
      ) : null}
    </div>
  );
};
